import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { map } from 'rxjs/operators';

// import { ToastComponent } from './toast.component';
import { ToastItem, ToastPosition, ToastService } from '@core/toast';
import { ToastComponent } from '@core/ui/components/toast/toast.component';

type Grouped = Record<ToastPosition, ToastItem[]>;

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule, ToastComponent],
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastContainerComponent {
  constructor(public toast: ToastService) {}

  groups$ = this.toast.toasts$.pipe(
    map(list => list.reduce((acc, t) => {
      (acc[t.position] ??= []).push(t);
      return acc;
    }, {} as Grouped))
  );

  positions: ToastPosition[] = [
    'top-left','top-center','top-right',
    'bottom-left','bottom-center','bottom-right'
  ];

  trackById(_i: number, t: ToastItem) { return t.id; }
}
